import { render, staticRenderFns } from "./project-assignments-preview.vue?vue&type=template&id=763c640e"
import script from "./project-assignments-preview.vue?vue&type=script&lang=js"
export * from "./project-assignments-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports